import type { HdmgdjConfig } from "@/config/hdmgdjConfig";

interface HdmgdjDownloadPlatformsProps {
  config: HdmgdjConfig;
}

export default function HdmgdjDownloadPlatforms({ config }: HdmgdjDownloadPlatformsProps) {
  return (
    <section className="w-full bg-background-50 py-16 md:py-20">
      <div className="hdmgdj-container">
        <div className="hdmgdj-reveal max-w-2xl">
          <span className="inline-flex items-center gap-2 text-accent-600 text-[14px] font-label font-bold">
            <i className="ri-apps-2-line text-lg" />
            选择你的设备
          </span>
          <h2 className="mt-3 font-heading text-foreground-950 text-[30px] md:text-[38px] leading-tight">
            支持 Android / iOS / HarmonyOS / Windows
          </h2>
          <p className="mt-4 text-[15px] leading-8 text-foreground-600">
            点击对应平台的下载按钮，即可跳转官方地址获取黄豆魔改短剧安装包，全程免费。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {config.platforms.map((platform, index) => (
            <article
              key={platform.key}
              className="hdmgdj-reveal flex flex-col bg-background-100 border border-background-200 rounded-lg p-5 hover:border-primary-300 transition-colors"
              style={{ transitionDelay: `${index * 60}ms` }}
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 text-2xl">
                <i className={platform.icon} />
              </span>
              <h3 className="mt-4 text-[17px] font-bold font-label text-foreground-950">
                {platform.name}
              </h3>
              <p className="mt-2 text-[14px] leading-7 text-foreground-600 flex-1">{platform.desc}</p>
              <p className="mt-3 text-[12px] font-label text-secondary-700">{platform.note}</p>
              <a
                href={platform.url}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-flex items-center justify-center gap-2 h-11 rounded-md bg-primary-500 text-foreground-950 text-[15px] font-label font-bold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-download-2-line text-lg" />
                立即下载
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}